module.exports = __webpack_public_path__ + "img/36.65a95361.jpg";